// extracted by css-extract-rspack-plugin
module.exports =  {"fullscreen-video":"FullScreenVideo-zQst__fullscreen-video","video-holder":"FullScreenVideo-VLqb__video-holder","video":"FullScreenVideo-EbHB__video"};